// Helpers for the IH-2079 activation link warning (MVP).
//
// The MVP rule is intentionally relaxed: any use of the activation variable
// in the email body counts. Coherent link usage is assumed. If misuse is
// observed, harden `containsActivationVariable` to require the variable
// inside a link `href`.

const ACTIVATION_VARIABLE = 'activation_url';

const ACTIVATION_FAMILIES = [
  'course_welcome',
  'course_welcome_preparation',
  'course_welcome_b2b',
];

const ACTIVATION_GUIDE_URL =
  'https://ironhack.notion.site/CT-Activation-link-in-welcome-emails-3d5396f8d1fe818aaab1e4dec4bde38b';

const isActivationFamily = (family) => ACTIVATION_FAMILIES.includes(family);

const containsActivationVariable = (content) => {
  if (!content) return false;
  if (typeof content === 'string') return content.includes(ACTIVATION_VARIABLE);
  try {
    return JSON.stringify(content).includes(ACTIVATION_VARIABLE);
  } catch (error) {
    return false;
  }
};

export {
  ACTIVATION_FAMILIES,
  ACTIVATION_GUIDE_URL,
  ACTIVATION_VARIABLE,
  containsActivationVariable,
  isActivationFamily,
};
